import type { ReactNode } from 'react';
import { formatCurrency, formatDate } from '@/utils/formatters';
import type { DrawdownBatch } from '@/types/drawdown';

interface DrawdownBatchDetailsProps {
  currentBatch: DrawdownBatch;
  actions?: ReactNode;
}

export const DrawdownBatchDetails = ({
  currentBatch,
  actions,
}: DrawdownBatchDetailsProps) => (
  <div className="flex items-center justify-between gap-4 flex-wrap border-b pb-3.5 mb-2">
    <div className="flex items-center gap-x-4 gap-y-1 flex-wrap text-sm text-muted-foreground">
      <span>
        <span className="text-muted-foreground/70">Notice</span>{' '}
        <b className="font-semibold text-foreground">
          {formatDate(
            currentBatch.actual_notice_date ?? currentBatch.notice_date
          )}
        </b>
      </span>
      <span>
        <span className="text-muted-foreground/70">Due</span>{' '}
        <b className="font-semibold text-foreground">
          {formatDate(currentBatch.due_date)}
        </b>
      </span>
      <span>
        <span className="text-muted-foreground/70">Amount</span>{' '}
        <b className="font-semibold text-foreground">
          {formatCurrency(currentBatch.total_amount)}
        </b>
      </span>
      <span>
        <span className="text-muted-foreground/70">Investors</span>{' '}
        <b className="font-semibold text-foreground">
          {currentBatch.investor_count}
        </b>
      </span>
      <span className="h-1 w-1 rounded-full bg-muted-foreground/40" />
      <span>
        {currentBatch.emails_sent} emails sent · {currentBatch.pdfs_completed}{' '}
        PDFs
      </span>
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);
